var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.9464L3.55286 7.49922L4.65078 6.36953L7.21875 8.9375V0.1875H8.78125V8.9375L11.3492 6.36953L12.4471 7.49922L8 11.9464ZM2.07057 15.8125C1.54436 15.8125 1.09896 15.6302 0.734375 15.2656C0.369792 14.901 0.1875 14.4556 0.1875 13.9294V11.1049H1.75V13.9294C1.75 14.0096 1.78342 14.0831 1.85026 14.1497C1.91693 14.2166 1.99036 14.25 2.07057 14.25H13.9294C14.0096 14.25 14.0831 14.2166 14.1497 14.1497C14.2166 14.0831 14.25 14.0096 14.25 13.9294V11.1049H15.8125V13.9294C15.8125 14.4556 15.6302 14.901 15.2656 15.2656C14.901 15.6302 14.4556 15.8125 13.9294 15.8125H2.07057Z",
    fill: "#A14DEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDownloadIcon);
export default __webpack_public_path__ + "static/media/RedDownloadIcon.0a714c8fe985bc96bca1275a9e962b44.svg";
export { ForwardRef as ReactComponent };